import React from 'react'
import useNewItemChange from '../../../../../../../../../EHR/EHR Settings/Templates/OpenTemplate/FormBuilder/hooks/useNewItemChange';
import ShowItemContent from './ShowItemContent';

const YesNoQuestion = ({ item, setItem, validations, activeAccordion, isGroupNote, ...props }) => {
  // let activeAccordion = 'Intake Form';
  const { handleSetAnswer } = useNewItemChange(setItem, 'Viewer', activeAccordion);
  const key = `${props?.itemRefKey}${item?.ItemID}`;
  // console.log("Itemkey",item?.name, key)
  return (
    <div className="d-flex gap-10">
      <div className="ar-form-counter flex-center">
        <p className='text text-black'>{props?.itemCount}</p>
      </div>
      <div className='content-box d-flex flex-column gap-6 w-100'>
        <p className={`heading fs-13 d-flex gap-01 ${validations?.isInvalid ? 'Denied-clr' : ''}`}>
          {/* {item.content || '[Enter prompt or question]'} */}
          {ShowItemContent(item, isGroupNote)}
          {/* \\ Required icon commented \\ */}
          {/* {[true, "true"].includes(item?.isRequired) ? <span className="text font-m Denied-clr fs-14">*</span> : <></>} */}
        </p>

        <div className="d-flex align-items-center gap-20 w-100">
          <label className="ar_radio-btn d-flex align-items-center gap-6">
            <input
              type="radio"
              id={`yes-${key}`}
              name={`binary-${key}`}
              value="Yes"
              checked={item.answer === 'Yes'}  // Controlled by state
              onChange={(e) => handleSetAnswer(e, item)}
            />
            <p className="text ar-orange-text" htmlFor={`yes-${key}`}>Yes</p>
          </label>
          <label className="ar_radio-btn d-flex align-items-center gap-6">
            <input
              type="radio"
              // type="radio"
              id={`no-${key}`}
              name={`binary-${key}`}
              value="No"
              checked={item.answer === 'No'}  // Controlled by state
              onChange={(e) => handleSetAnswer(e, item)}
            />
            <p className="text ar-orange-text" htmlFor={`no-${key}`}>No</p>
          </label>
        </div>
      </div>
    </div>
  );
};

export default YesNoQuestion;